import React, { useState, useEffect } from "react";
import "./Cermati.css";
import { getCurrentUser } from "../services/api";
import { toast } from "react-toastify";
import { downloadPdf, printPdf, sharePdfLink } from "../utils/pdfActions";

// PDF Viewer
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

// Import PDF files - sesuaikan path dengan file PDF Anda
import pdf1 from "../assets/dasar-pembelajaran.pdf";
import pdf2 from "../assets/dimensi.pdf";
import pdf3 from "../assets/panduan-pembelajaran.pdf";
import pdf4 from "../assets/panduan-pengembangan.pdf";
import pdf5 from "../assets/RPP.pdf";
import pdf6 from "../assets/struktur-narasi-cerdas.pdf";
import pdf7 from "../assets/cerdas-menulis-cerita.pdf";




const Cermati = () => {
  const [openDialog, setOpenDialog] = useState(null);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [userRole, setUserRole] = useState("siswa");

  useEffect(() => {
    const me = getCurrentUser();
    if (me?.role) setUserRole(me.role);
  }, []);


  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  // Data PDF untuk Elemen Capaian Pembelajaran
  const pdfList = [
    {
      id: 1,
      name: "Dasar-Dasar Pembelajaran DGST",
      file: pdf1,
      // description: "Materi dasar tentang konsep pembelajaran",
      color: "#4ECDC4"
    },
    {
      id: 2,
      name: "Dimensi, Elemen, Subelemen Profil",
      file: pdf2,
      // description: "Berbagai metode evaluasi pembelajaran",
      color: "#FF6B6B"
    },
    {
      id: 3,
      name: "Panduan Pembelajaran dan Asesmen 2025",
      file: pdf3,
      // description: "Struktur dan implementasi kurikulum",
      color: "#FFD93D"
    },
    {
      id: 4,
      name: "Panduan Pengembangan",
      file: pdf4,
      // description: "Panduan praktis untuk pengajar",
      color: "#6A0572"
    }

  ];
  const pdfList2 = [

    {
      id: 1,
      name: "RPP",
      file: pdf5,
      // description: "Panduan praktis untuk pengajar",
      color: "#4ECDC4"
    },

  ];

  const pdfList3 = [

    {
      id: 1,
      name: "Struktur Narasi CERDAS",
      file: pdf6,
      // description: "Panduan praktis untuk pengajar",
      color: "#4ECDC4"
    },
    {
      id: 2,
      name: "Cerdas Menulis Cerita",
      file: pdf7,
      // description: "Panduan praktis untuk pengajar",
      color: "#6A0572"
    },

  ];

  const handleOpen = (boxName) => {
    setOpenDialog(boxName);
    setSelectedPdf(pdfList[0]); // Set PDF pertama sebagai default
  };
  const handleOpen2 = (boxName) => {
    setOpenDialog(boxName);
    setSelectedPdf(pdfList2[0]); // Set PDF pertama sebagai default
  };
  const handleOpen3 = (boxName) => {
    setOpenDialog(boxName);
    setSelectedPdf(pdfList3[0]); // Set PDF pertama sebagai default
  };

  const handleClose = () => {
    setOpenDialog(null);
    setSelectedPdf(null);
  };

  const handlePdfSelect = (pdf) => {
    setSelectedPdf(pdf);
  };

  const pdfFileName = (pdf) =>
    pdf?.name ? `${pdf.name.replace(/\s+/g, "-").toLowerCase()}.pdf` : "materi.pdf";

  const handleDownloadSelected = () => {
    if (!selectedPdf?.file) return toast.warn("Pilih PDF terlebih dahulu");
    downloadPdf(selectedPdf.file, pdfFileName(selectedPdf));
    toast.success("Unduhan dimulai");
  };

  const handlePrintSelected = () => {
    if (!selectedPdf?.file) return toast.warn("Pilih PDF terlebih dahulu");
    if (printPdf(selectedPdf.file)) toast.info("Buka tab baru untuk mencetak");
    else toast.error("Tidak dapat membuka PDF");
  };

  const handleShareSelected = async () => {
    if (!selectedPdf?.file) return toast.warn("Pilih PDF terlebih dahulu");
    const ok = await sharePdfLink(selectedPdf.file, selectedPdf.name);
    if (ok) toast.success("Tautan PDF disalin");
    else toast.error("Gagal membagikan tautan");
  };

  const renderQuickActions = () => (
    <div className="quick-actions-sidebar">
      <h4>🚀 Aksi Cepat</h4>
      <div className="action-buttons">
        <button type="button" className="action-btn download" onClick={handleDownloadSelected}>
          📥 Unduh
        </button>
        <button type="button" className="action-btn print" onClick={handlePrintSelected}>
          🖨️ Print
        </button>
        <button type="button" className="action-btn share" onClick={handleShareSelected}>
          📤 Bagikan
        </button>
        {userRole === "guru" && (
          <div className="guru-soon-badges">
            <span className="soon-badge">➕ Add PDF — Segera</span>
            <span className="soon-badge">🔗 Add Link — Segera</span>
          </div>
        )}
      </div>
    </div>
  );

  const getDialogContent = (boxName) => {
    switch (boxName) {
      case "Elemen Capaian":
        return (
          <div className="pdf-viewer-layout">
            {/* PDF Sidebar */}
            <div className="pdf-sidebar">
              <div className="sidebar-header">
                <h3>📚 Materi Pembelajaran</h3>
                <span className="pdf-count">{pdfList.length} PDF Tersedia</span>
              </div>

              <div className="pdf-list">
                {pdfList.map(pdf => (
                  <div
                    key={pdf.id}
                    className={`pdf-item ${selectedPdf?.id === pdf.id ? "active" : ""}`}
                    onClick={() => handlePdfSelect(pdf)}
                    style={{ borderLeft: `4px solid ${pdf.color}` }}
                  >
                    <div className="pdf-item-icon">📄</div>
                    <div className="pdf-item-content">
                      <div className="pdf-item-title">{pdf.name}</div>
                      <div className="pdf-item-desc">{pdf.description}</div>
                    </div>
                    <div className="pdf-item-badge" style={{ background: pdf.color }}>
                      {pdf.id}
                    </div>
                  </div>
                ))}
              </div>

              {renderQuickActions()}
            </div>

            {/* PDF Viewer Area */}
            <div className="pdf-viewer-area">
              {selectedPdf && (
                <>
                  <div className="pdf-viewer-header">
                    <div className="pdf-info">
                      <h3>{selectedPdf.name}</h3>
                      <p>{selectedPdf.description}</p>
                    </div>
                    <div className="pdf-status">
                      <span className="status-badge">🟢 Tersedia</span>
                    </div>
                  </div>

                  <div className="pdf-container">
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                      <Viewer
                        fileUrl={selectedPdf.file}
                        plugins={[defaultLayoutPluginInstance]}
                        defaultScale={1.0}
                      />
                    </Worker>
                  </div>
                </>
              )}
            </div>
          </div>
        );

        case "Pelaksanaan Pembelajaran":
        return (
          <div className="pdf-viewer-layout">
            {/* PDF Sidebar */}
            <div className="pdf-sidebar">
              <div className="sidebar-header">
                <h3>📚 Materi Pembelajaran</h3>
                <span className="pdf-count">{pdfList2.length} PDF Tersedia</span>
              </div>

              <div className="pdf-list">
                {pdfList2.map(pdf => (
                  <div
                    key={pdf.id}
                    className={`pdf-item ${selectedPdf?.id === pdf.id ? "active" : ""}`}
                    onClick={() => handlePdfSelect(pdf)}
                    style={{ borderLeft: `4px solid ${pdf.color}` }}
                  >
                    <div className="pdf-item-icon">📄</div>
                    <div className="pdf-item-content">
                      <div className="pdf-item-title">{pdf.name}</div>
                      <div className="pdf-item-desc">{pdf.description}</div>
                    </div>
                    <div className="pdf-item-badge" style={{ background: pdf.color }}>
                      {pdf.id}
                    </div>
                  </div>
                ))}
              </div>

              {renderQuickActions()}
            </div>

            {/* PDF Viewer Area */}
            <div className="pdf-viewer-area">
              {selectedPdf && (
                <>
                  <div className="pdf-viewer-header">
                    <div className="pdf-info">
                      <h3>{selectedPdf.name}</h3>
                      <p>{selectedPdf.description}</p>
                    </div>
                    <div className="pdf-status">
                      <span className="status-badge">🟢 Tersedia</span>
                    </div>
                  </div>

                  <div className="pdf-container">
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                      <Viewer
                        fileUrl={selectedPdf.file}
                        plugins={[defaultLayoutPluginInstance]}
                        defaultScale={1.0}
                      />
                    </Worker>
                  </div>
                </>
              )}
            </div>
          </div>
        );

      case "Materi Pembelajaran":
        return (
          <div className="pdf-viewer-layout">
            {/* PDF Sidebar */}
            <div className="pdf-sidebar">
              <div className="sidebar-header">
                <h3>📚 Materi Pembelajaran</h3>
                <span className="pdf-count">{pdfList3.length} PDF Tersedia</span>
              </div>

              <div className="pdf-list">
                {pdfList3.map(pdf => (
                  <div
                    key={pdf.id}
                    className={`pdf-item ${selectedPdf?.id === pdf.id ? "active" : ""}`}
                    onClick={() => handlePdfSelect(pdf)}
                    style={{ borderLeft: `4px solid ${pdf.color}` }}
                  >
                    <div className="pdf-item-icon">📄</div>
                    <div className="pdf-item-content">
                      <div className="pdf-item-title">{pdf.name}</div>
                      <div className="pdf-item-desc">{pdf.description}</div>
                    </div>
                    <div className="pdf-item-badge" style={{ background: pdf.color }}>
                      {pdf.id}
                    </div>
                  </div>
                ))}
              </div>

              {/* External Links Section */}
              <div className="external-links-section">
                <h4>🌐 Sumber Belajar Eksternal</h4>
                <div className="external-links">
                  <a
                    href="https://g.co/gemini/share/6f5ef3cffa24"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="external-link"
                  >
                    <div className="external-link-icon">🎨</div>
                    <div className="external-link-content">
                      <div className="external-link-title">Digital Storytelling (Link Gemini)</div>
                      {/* <div className="external-link-desc">Sumber belajar interaktif online</div> */}
                    </div>
                  </a>

                  <a
                    href="https://g.co/gemini/share/ac65ad7d64be"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="external-link"
                  >
                    <div className="external-link-icon">🎬</div>
                    <div className="external-link-content">
                      <div className="external-link-title">ADIKSIMBA (Link Gemini)</div>
                      {/* <div className="external-link-desc">Koleksi video edukasi lengkap</div> */}
                    </div>
                  </a>

                  <a
                    href="https://g.co/gemini/share/b0d8b66bc3f7"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="external-link"
                  >
                    <div className="external-link-icon">✍️</div>
                    <div className="external-link-content">
                      <div className="external-link-title">Menulis Narasi (Link Gemini)</div>
                      {/* <div className="external-link-desc">Latihan soal dan evaluasi</div> */}
                    </div>
                  </a>
                </div>
              </div>

              {renderQuickActions()}
            </div>

            {/* PDF Viewer Area */}
            <div className="pdf-viewer-area">
              {selectedPdf && (
                <>
                  <div className="pdf-viewer-header">
                    <div className="pdf-info">
                      <h3>{selectedPdf.name}</h3>
                      <p>{selectedPdf.description}</p>
                    </div>
                    <div className="pdf-status">
                      <span className="status-badge">🟢 Tersedia</span>
                    </div>
                  </div>

                  <div className="pdf-container">
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                      <Viewer
                        fileUrl={selectedPdf.file}
                        plugins={[defaultLayoutPluginInstance]}
                        defaultScale={1.0}
                      />
                    </Worker>
                  </div>
                </>
              )}
            </div>
          </div>
        );

      default:
        return "";
    }
  };

  return (
    <div className="cermati-content">
      <header className="cermati-header">
        <div className="wave-left">👋</div>
        <h1>Selamat Datang di Dunia Belajar Ceria!</h1>
        <div className="wave-right">👋</div>
      </header>

      <div className="cermati-boxes">
        <div className="box green" onClick={() => handleOpen("Elemen Capaian")}>
          <div className="box-icon">🎯</div>
          <div className="box-title">Elemen Capaian Pembelajaran</div>
          <div className="box-subtitle">Target Belajar Menyenangkan</div>
        </div>

        <div className="box yellow" onClick={() => handleOpen2("Pelaksanaan Pembelajaran")}>
          <div className="box-icon">📚</div>
          <div className="box-title">Rencana Pembelajaran</div>
          <div className="box-subtitle">Cara Seru Belajar</div>
        </div>

        <div className="box pink" onClick={() => handleOpen3("Materi Pembelajaran")}>
          <div className="box-icon">🌟</div>
          <div className="box-title">Materi Pembelajaran</div>
          <div className="box-subtitle">Bahan Ajar Menarik</div>
        </div>
      </div>

      {openDialog && (
        <div className="dialog-overlay" onClick={handleClose}>
          <div
            className={`dialog-box ${
              ["Elemen Capaian", "Pelaksanaan Pembelajaran", "Materi Pembelajaran"].includes(openDialog)
                ? "pdf-dialog"
                : ""
            }`}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Dialog Header dengan Tombol Close */}
            <div className="dialog-header">
              <h2>
                {openDialog}
                <span className="dialog-icon">
                  {openDialog === "Elemen Capaian" && "🎯"}
                  {openDialog === "Pelaksanaan Pembelajaran" && "📚"}
                  {openDialog === "Materi Pembelajaran" && "🌟"}
                </span>
              </h2>
              <button className="dialog-close-btn" onClick={handleClose}>
                ✕
              </button>
            </div>

            {/* Dialog Content */}
            <div className="dialog-content">
              {getDialogContent(openDialog)}
            </div>
            
            {/* HAPUS dialog-actions karena tombol close sudah di header */}
          </div>
        </div>
      )}
    </div>
  );
};

export default Cermati;